<template>
	<Layout>
		<div class="l-container">
			<div class="arena-message">
				<Icon
					icon-name="sad"
					size="xxxl"
					class="arena-message__icon"
				/>
				<SectionTitle :title="title" />
				<p
					v-if="error"
					class="message"
				>
					{{ $I18n.trans('arena.login.errors.' + error) }}
				</p>
				<p
					v-else-if="message"
					class="message"
				>
					{{ message }}
				</p>
				<Button
					v-if="buttonText && buttonLink"
					:text="buttonText"
					:link="buttonLink"
					theme="dark"
					class="arena-message__button"
				/>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import Icon from '@shared/components/Icon';
import Button from '@shared/components/Button';
import SectionTitle from '@js/components/SectionTitle';

export default {
	name:       'ViewError',
	components: { Layout, Icon, Button, SectionTitle },
	props:      {
		message: {
			type:     String,
			required: false,
			default:  null,
		},
		error: {
			type:     String,
			required: false,
			default:  null,
		},
		buttonText: {
			type:     String,
			required: true,
		},
		buttonLink: {
			type:     String,
			required: true,
		},
		title: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style>
	.message {
		margin-bottom: 15px;
	}
</style>
